const aaa = [
	{
		path: "advertising",
		component: () => import("@/views/program/advertising.vue"),
		meta:{title:'广告位'},
	},
	
]
export default aaa;